export default __webpack_public_path__ + "static/media/number9.9fbc267c.svg";